import LandingPromo from './LandingPromo'
import {connect} from 'react-redux'

const mapDispatchToProps = (dispatch, ownProps) => {
  return {}
}

const mapStateToProps = (state, ownProps) => {
  return {
    isMobileLayout: state.isMobileLayout
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LandingPromo)



// WEBPACK FOOTER //
// ./client/components/LandingPromo/index.js